export const ClaimType = {
    ADD_CHILD_REPORT: "ADD_CHILD_REPORT",
    ADD_CORRECTION: "ADD_CORRECTION",
    ADD_PORT_CODE: "ADD_PORT_CODE",
    ADD_REPORT: "ADD_REPORT",
    ADD_ROLE: "ADD_ROLE",
    ADD_USER: "ADD_USER",
    ADD_VESSEL: "ADD_VESSEL",
    ADD_VOYAGE: "ADD_VOYAGE",
    ADD_VOYAGE_BDN: "ADD_VOYAGE_BDN",
    ADD_WCN: "ADD_WCN",
    ASSIGN_REPORT: "ASSIGN_REPORT",
    ASSIGN_ROLE: "ASSIGN_ROLE",
    ASSIGN_VERIFIER: "ASSIGN_VERIFIER",
    ASSIGN_WCN: "ASSIGN_WCN",
    AVAILABLE_FOR_CLIENT_CHECK: "AVAILABLE_FOR_CLIENT_CHECK",
    CHANGE_OFFICE_SIGN: "CHANGE_OFFICE_SIGN",
    CHANGE_PASSWORD: "CHANGE_PASSWORD",
    CLAIM_REPORT: "CLAIM_REPORT",
    COMPLETE_VERIFICATION: "COMPLETE_VERIFICATION",
    DELETE_CHILD_REPORT: "DELETE_CHILD_REPORT",
    DELETE_CORRECTION: "DELETE_CORRECTION",
    DELETE_DOCUMENT: "DELETE_DOCUMENT",
    DELETE_PORT_CODE: "DELETE_PORT_CODE",
    DELETE_REPORT: "DELETE_REPORT",
    DELETE_ANY_REPORT: "DELETE_ANY_REPORT",
    DELETE_VESSEL: "DELETE_VESSEL",
    DELETE_VOYAGE: "DELETE_VOYAGE",
    DELETE_VOYAGE_BDN: "DELETE_VOYAGE_BDN",
    DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT",
    DOWNLOAD_TEMPLATE: "DOWNLOAD_TEMPLATE",
    EXPORT_DCS_DATA_REPORT: "EXPORT_DCS_DATA_REPORT",
    EXPORT_EUMRV_DATA_REPORT: "EXPORT_EUMRV_DATA_REPORT",
    EXPORT_FEU_DATA_REPORT: "EXPORT_FEU_DATA_REPORT",
    EXPORT_UKMRV_DATA_REPORT: "EXPORT_UKMRV_DATA_REPORT",
    GENERATE_ETS_DOCUMENT: "GENERATE_ETS_DOCUMENT",
    GENERATE_THETIS: "GENERATE_THETIS",
    LOGIN: "LOGIN",
    PUBLISH_DOCUMENT: "PUBLISH_DOCUMENT",
    REGISTER: "REGISTER",
    REJECT_VERIFICATION: "REJECT_VERIFICATION",
    SET_NOTIFICATION: "SET_NOTIFICATION",
    SHOW_IMPORT_ADDITIONAL_DATA: "SHOW_IMPORT_ADDITIONAL_DATA",
    SUBMIT_DOCUMENT: "SUBMIT_DOCUMENT",
    SUBMIT_REPORT: "SUBMIT_REPORT",
    UPDATE_CORRECTION: "UPDATE_CORRECTION",
    RESOLVE_CORRECTION: "RESOLVE_CORRECTION",
    UPDATE_DOCUMENT: "UPDATE_DOCUMENT",
    UPDATE_PORT_CODE: "UPDATE_PORT_CODE",
    UPDATE_USER: "UPDATE_USER",
    UPDATE_VESSEL: "UPDATE_VESSEL",
    UPDATE_VOYAGE: "UPDATE_VOYAGE",
    UPDATE_VOYAGE_BDN: "UPDATE_VOYAGE_BDN",
    UPDATE_WCN: "UPDATE_WCN",
    UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
    VALIDATE_MIS: "VALIDATE_MIS",
    VIEW_ABS_INTERNAL_COLUMNS: "VIEW_ABS_INTERNAL_COLUMNS",
    VIEW_ADMIN: "VIEW_ADMIN",
    VIEW_CALCULATED_DIFF_MATERIALITY: "VIEW_CALCULATED_DIFF_MATERIALITY",
    VIEW_CHILD_REPORT: "VIEW_CHILD_REPORT",
    VIEW_CII: "VIEW_CII",
    VIEW_CLIENT_DATA: "VIEW_CLIENT_DATA",
    VIEW_COMPANY_EMISSION_VERIFICATION_FORM: "VIEW_COMPANY_EMISSION_VERIFICATION_FORM",
    VIEW_CORRECTION: "VIEW_CORRECTION",
    VIEW_DASHBOARD: "VIEW_DASHBOARD",
    VIEW_DOCUMENT: "VIEW_DOCUMENT",
    VIEW_EVENT_LOGS: "VIEW_EVENT_LOGS",
    VIEW_GLOBAL_ERROR: "VIEW_GLOBAL_ERROR",
    VIEW_MSTDATA: "VIEW_MSTDATA",
    VIEW_NOTIFICATION: "VIEW_NOTIFICATION",
    VIEW_PORT_CODE: "VIEW_PORT_CODE",
    VIEW_REPORT: "VIEW_REPORT",
    VIEW_REVIEW_ENGINEER: "VIEW_REVIEW_ENGINEER",
    VIEW_RISK_ASSESSMENT: "VIEW_RISK_ASSESSMENT",
    VIEW_ROLE: "VIEW_ROLE",
    VIEW_USER: "VIEW_USER",
    VIEW_VERIFICATION_TAB: "VIEW_VERIFICATION_TAB",
    VIEW_VERIFY_ENGINEER: "VIEW_VERIFY_ENGINEER",
    VIEW_VESSEL: "VIEW_VESSEL",
    VIEW_VOYAGE: "VIEW_VOYAGE",
    VIEW_VOYAGE_BDN: "VIEW_VOYAGE_BDN",
    VIEW_ABS_WCN: "VIEW_ABS_WCN",
    VIEW_WCN: "VIEW_WCN",
    VIEW_PLANVERIFICATION_PLANGENERATOR_TAB: "VIEW_PLANVERIFICATION_PLANGENERATOR_TAB",
    VIEW_PLANVERIFICATION_DOCUMENTS_TAB: "VIEW_PLANVERIFICATION_DOCUMENTS_TAB",
    VIEW_PLANVERIFICATION_CORRECTIONS_TAB: "VIEW_PLANVERIFICATION_CORRECTIONS_TAB",
    VIEW_PLANVERIFICATION_VERIFICATION_TAB: "VIEW_PLANVERIFICATION_VERIFICATION_TAB",
    VIEW_PLANVERIFICATION: "VIEW_PLANVERIFICATION",
    VIEW_DEBUG_INFO: "VIEW_DEBUG_INFO",
};
export const ClaimURLs = {
    GetUserClaims: `/api/Accounts/GetUserClaims`
}
